<template>
  <nav
    class="navbar navbar-vertical navbar-light fixed-start navbar-expand-md d-md-none"
    id="sidebar"
  >
    <div class="container-fluid">
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#sidebarCollapse"
        aria-controls="sidebarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <router-link
        class="navbar-brand text-start d-flex align-items-center"
        :to="paths.home"
      >
        <!-- TODO: o pro usa sidebar_logo.svg; falta um SVG do logo do paciente -->
        <img
          src="@/assets/img/navlogo.png"
          class="navbar-brand-img rounded me-2"
          alt=""
        />
        <!-- EXCLUSIVO DO MAIN: versão/ambiente ao lado do logo -->
        <VersionComponent />
      </router-link>

      <!-- o avatar leva ao Mais (o Sair fica lá, com confirmação) -->
      <router-link v-if="session" :to="paths.more" class="navbar-user d-md-none" id="sidebar-profile">
        <div class="avatar avatar-sm">
          <img v-if="session?.formatted_image" :src="session?.formatted_image" class="avatar-img rounded-circle" alt="" />
          <i v-else class="fa-solid fa-user-circle text-muted" style="font-size: 40px" />
        </div>
      </router-link>

      <div class="navbar-collapse collapse" id="sidebarCollapse">
        <ul class="navbar-nav">
          <!-- EXCLUSIVO DO MAIN: o app do paciente tem páginas públicas -->
          <router-link
            v-if="!session"
            active-class="router-link-active"
            :to="paths.login"
          >
            <li class="nav-item">
              <a class="nav-link text-paragraph">Entrar</a>
            </li>
          </router-link>
          <template v-else>
            <template v-for="link in links" :key="link.title">
              <li
                v-if="link.navigate"
                class="nav-item cursor-pointer"
                @click="link.navigate()"
              >
                <a class="nav-link text-paragraph">{{ link.title }}</a>
              </li>
              <router-link
              v-else
              active-class="nav-route-matched"
              exact-active-class="nav-route-exact"
              :class="{ 'router-link-active': isNavLinkActive(route.path, link.to) }"
              :to="link.to"
            >
                <li class="nav-item">
                  <a class="nav-link text-paragraph">{{ link.title }}</a>
                </li>
              </router-link>
            </template>
          </template>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useSessionStore } from "@/store/useSessionStore";
import paths from "@/router/paths";
import { getNavLinks, isNavLinkActive } from "./navLinks";
import { useRoute } from "vue-router";

const route = useRoute();
const { session } = storeToRefs(useSessionStore());

const links = getNavLinks(paths);

</script>
